import { toast } from "@/v2-ui/toast"
import CustomerPicker from "@/v2-backoffice-client/customer/CustomerPicker"
import { useLinkBillingAccountMutation } from "@/v2-backoffice-client/license/account/view/license.account.link.mutation"
import { evictBillingAccountQueries } from "@/v2-backoffice-client/license/license.utils"

export type LicenseAccountLinkPickerProps = {
  accountId: number
  accountName: string | null | undefined
}

// Links the account to ANY customer, searched by name — the escape hatch for
// accounts with no org-number candidate at all: foreign companies whose
// number format the linker can't match (Swedish/UK org numbers), or entities
// whose customer record carries no number yet. Same mutation and guards as
// the candidate buttons.
function LicenseAccountLinkPicker(props: LicenseAccountLinkPickerProps) {
  const { accountId, accountName } = props

  const [linkAccount, { loading }] = useLinkBillingAccountMutation({
    update: evictBillingAccountQueries,
    onCompleted(data) {
      toast({
        variant: "success",
        title: "Account linked",
        description: `${accountName ?? "The account"} now bills ${
          data.linkBillingAccount.CustomerName ?? "the selected customer"
        } — invoices and licenses flow to its panel from the next sync.`,
      })
    },
    onError(mutationError) {
      toast({
        variant: "destructive",
        title: "Could not link",
        description: mutationError.message,
      })
    },
  })

  return (
    <CustomerPicker
      disabled={loading}
      data-feature-code="UI_BackofficeBillingAccount_Matches_LinkPicker"
      onSelect={(customer) => {
        void linkAccount({
          variables: { accountId, customerId: customer.Id },
        })
      }}
    >
      Link another customer...
    </CustomerPicker>
  )
}

export default LicenseAccountLinkPicker
